import { AHInput, Box } from "arkh";
import { InteractionManager } from "react-native";
import React, { useCallback } from "react";

import { TaskExecutionProps } from "./TaskExecutionProps";
import { useDebouncedMutation } from "../../../../common/Utils/useDebouncedMutation";

import { useIntl } from "react-intl";
import { graphql, useFragment, useMutation } from "react-relay";
import { TaskExecutionTextComponent$key } from "./__generated__/TaskExecutionTextComponent.graphql";
import { TaskExecutionTextSaveTextMutation } from "./__generated__/TaskExecutionTextSaveTextMutation.graphql";
import { usePersistedEmployeeId } from "@/src/OS/Login/usePersistedEmployeeId";

type InputProps = {
  value?: string;
  onSave: (newValue: string) => void;
  disabled: boolean;
  onNext?: () => void;
  onFocus?: () => void;
};

const inpStyle = {
  borderBottomWidth: 1,
};
const Input = (props: InputProps) => {
  const [value, setValue] = useDebouncedMutation(
    props.value ? props.value : "",
    props.onSave
  );
  const intl = useIntl();
  return (
    <Box spaceBottom="large">
      <AHInput
        placeholder={intl.formatMessage({
          defaultMessage: "Answer",
          description: "TaskExeText: Answer placeholder",
        })}
        editable={!props.disabled}
        enablesReturnKeyAutomatically
        returnKeyType="default"
        multiline
        onFocus={props.onFocus}
        scrollEnabled={false}
        onChangeText={setValue}
        value={value}
        spaceTop="large"
        spaceBottom="small"
        borderColor="border-primary"
        style={inpStyle}
      />
    </Box>
  );
};

type Props = Omit<
  TaskExecutionProps & { taskExecution: TaskExecutionTextComponent$key },
  "openIssue" | "openIssueFull" | "openInstructions" | "openImages"
>;

const TaskExecutionTextCMP = (props: Props) => {
  const taskExecution = useFragment(
    graphql`
      fragment TaskExecutionTextComponent on TaskExecutionText {
        id
        textValue
      }
    `,
    props.taskExecution
  );
  const { currentEmployeeId } = usePersistedEmployeeId();

  const [save] = useMutation<TaskExecutionTextSaveTextMutation>(graphql`
    mutation TaskExecutionTextSaveTextMutation(
      $id: ID!
      $value: String!
      $employeeId: ID
    ) {
      setTaskExecutionText(id: $id, value: $value, employeeId: $employeeId) {
        id
        textValue
        isCompleted
        routineOccasion {
          id
          status
        }
      }
    }
  `);

  const onSave = useCallback(
    (val: string) => {
      InteractionManager.runAfterInteractions(() => {
        save({
          variables: {
            id: taskExecution.id,
            value: val,
            employeeId: currentEmployeeId,
          },
        });
      });
    },
    [save, taskExecution.id, currentEmployeeId]
  );
  return (
    <Input
      value={taskExecution.textValue ?? undefined}
      onNext={props.onNext}
      onFocus={props.onFocus}
      disabled={props.disabled ?? false}
      onSave={onSave}
    />
  );
};

export const TaskExecutionText = React.memo(TaskExecutionTextCMP);
